import { render } from "./UpdateDocument.vue?vue&type=template&id=f5bc7ace&ts=true"
import script from "./UpdateDocument.vue?vue&type=script&lang=ts"
export * from "./UpdateDocument.vue?vue&type=script&lang=ts"

import "./UpdateDocument.vue?vue&type=style&index=0&id=f5bc7ace&lang=scss"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__